import React from "react";
import BaseIcon from "../../../components/BaseIcon";
import PropTypes from "prop-types";
import "./style.scss";

const baseNameSize = "-swiper-card-select";
const sizes = {
  small: `small${baseNameSize}`,
  medium: `medium${baseNameSize}`,
  large: `large${baseNameSize}`,
};
export default function SelectCard({ selected, onClick, size, className }) {
  SelectCard.propTypes = {
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    className: PropTypes.string,
    size: PropTypes.oneOf(["small", "medium", "large"]),
  };
  const cls = ["swiper-modal-card-select"];
  if (className) cls.push(className);
  return (
    <div
      onClick={onClick}
      className={`${cls.join(" ")} swiper-modal-card-select_${
        selected ? "selected" : ""
      } ${sizes[size]} `}
    >
      {selected && (
        <BaseIcon name="checked" className="swiper-modal-card-select__check" />
      )}
    </div>
  );
}
